import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DispatchStatePhase } from 'src/app/core/interfaces/dispatchStatePhase';
import { Utils } from 'src/app/core/resources/utils';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PanelAssignmentService } from '../panel-assignment.service';

@Component({
  selector: 'app-change-dispatch-state-dialog',
  templateUrl: './change-dispatch-state-dialog.component.html',
  styleUrls: ['./change-dispatch-state-dialog.component.scss']
})
export class ChangeDispatchStateDialogComponent implements OnInit {
  public form: FormGroup = new FormGroup({
    state: new FormControl(''),
    observations: new FormControl('')
  });
  public operation: 'changeState' | 'changeObservations' = 'changeState';

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: {
      availableStates: DispatchStatePhase[];
      currentState?: string;
      currentObservations?: string;
      cargoId: string;
      operation: 'changeState' | 'changeObservations';
    },
    private readonly dialogRef: MatDialogRef<ChangeDispatchStateDialogComponent>,
    private readonly snackBarService: SnackBarService,
    public readonly utils: Utils,
    private readonly spinner: NgxSpinnerService,
    private readonly panelAssignmentService: PanelAssignmentService
  ) { }

  public ngOnInit(): void {
    this.operation = this.data.operation;
    if (this.operation === 'changeState') {
      this.form.get('state').setValidators([Validators.required]);
      if (this.data.currentState) this.form.get('state').setValue(this.data.currentState);
      if (this.data.currentObservations) this.form.get('observations').setValue(this.data.currentObservations);
    } else {
      if (this.data.currentObservations) this.form.get('observations').setValue(this.data.currentObservations);
      this.form.get('observations').setValidators([Validators.required, Validators.maxLength(240)]);
    }
  }

  public close(): void {
    this.dialogRef.close();
  }

  public onSubmit(): void {
    this.form.markAllAsTouched();
    this.form.get('observations').setValue(this.form.get('observations').value.trim());
    if (this.utils.errorMessagesCustomized(this.form.get('state'), 'estado del despacho')) return;
    if (this.utils.errorMessagesCustomized(this.form.get('observations'), 'observaciones', null, 240)) return;
    if (this.form.invalid) return this.snackBarService.openSnackBar('Hay errores en el formulario', undefined, 'alert');
    if (this.operation === 'changeState' && this.data.currentState === this.form.get('state').value && this.form.get('observations').value === this.data.currentObservations)
      return this.snackBarService.openSnackBar('No hay cambios para actualizar', undefined, 'alert');
    if (this.operation === 'changeObservations' && this.form.get('observations').value === this.data.currentObservations)
      return this.snackBarService.openSnackBar('No hay cambios para actualizar', undefined, 'alert');
    this.updateDispatchState();
  }

  private async updateDispatchState(): Promise<void> {
    this.spinner.show();
    try {
      const result = await this.panelAssignmentService.updateDispatchState(
        this.data.cargoId,
        this.form.get('state').value,
        this.form.get('observations').value
      ).toPromise();
      this.snackBarService.openSnackBar(result && result.message ? result.message : 'Estado del despacho actualizado correctamente', undefined, 'success');
      this.dialogRef.close({ state: true });
    } catch (error) {
      this.snackBarService.openSnackBar('Error al actualizar el estado del despacho del servicio', undefined, 'error');
    } finally {
      this.spinner.hide();
    }
  }
}
